// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sz-var-states[data-v-2fbf9e3e]::-webkit-scrollbar {\n  -webkit-appearance: none;\n  width: 5px;\n  height: 5px;\n  min-width: 8px !important;\n}\n.sz-var-states[data-v-2fbf9e3e]::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n.sz-var-states[data-v-2fbf9e3e]::-webkit-scrollbar-thumb {\n  border-radius: 4px;\n  background-color: rgba(0,0,0,0.1);\n  box-shadow: 0 0 1px rgba(255,255,255,0);\n}\n", ""]);
// Exports
module.exports = exports;
